import { Amount } from '@ui/components/Amount/Amount';
import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { SwitchVertical } from '@ui/components/icons';
import { GENERIC_DISPLAY_DECIMALS } from '@ui/constants/numbersDecimals';
import { formatNumber } from '@ui/lib/bignumber';
import { Button } from '@ui/lib/park/ui/button';
import { Icon } from '@ui/lib/park/ui/icon';
import { SetStateAction } from 'react';
import { Flex } from 'styled-system/jsx';

import { Value } from '../../types';

type Props = {
  isInputToken: boolean;
  setIsInputToken: (value: SetStateAction<boolean>) => void;
  setLocalValue: (value: SetStateAction<string>) => void;
  tokenSymbol?: string;
  value: Value;
};
export const CollateralValueEst = ({
  isInputToken,
  value,
  setIsInputToken,
  setLocalValue,
  tokenSymbol,
}: Props) => {
  if (tokenSymbol === 'USDC' || tokenSymbol === 'LVUSD') {
    return null;
  }
  
return (
    <Flex gap="2px" mt="-5px" ml="12px">
      {isInputToken ? (
        <AmountUsd
          textStyle="text.xsmall"
          color="greyWhite.lightGrey4"
          value={value?.usd || 0}
          opts={{
            prefix: '~$',
            displayDecimals: GENERIC_DISPLAY_DECIMALS,
          }}
          data-cy="CollateralValueEst-Usd"
          data-cy-value={value?.usd || 0}
        />
      ) : (
        <Amount
          textStyle="text.xsmall"
          color="greyWhite.lightGrey4"
          value={value?.token || 0}
          opts={{
            prefix: '~',
            displayDecimals: GENERIC_DISPLAY_DECIMALS,
          }}
          data-cy="CollateralValueEst-Token"
          data-cy-value={value?.token || 0}
        />
      )}
      <Button
        variant="round"
        h="unset"
        data-cy="SetIsInputToken-SwitchButton"
        onClick={() => {
          setIsInputToken((p) => {
            setLocalValue(
              p
                ? formatNumber(value?.usd || 0, {
                    displayDecimals: GENERIC_DISPLAY_DECIMALS,
                    isTrimTrailingZero: true,
                    isUseSeparator: false,
                  })
                : formatNumber(value?.token || 0, {
                    displayDecimals: GENERIC_DISPLAY_DECIMALS,
                    isTrimTrailingZero: true,
                    isUseSeparator: false,
                  }),
            );

            return !p;
          });
        }}
      >
        <Icon color="primary.orange" boxSize="14px">
          <SwitchVertical />
        </Icon>
      </Button>
    </Flex>
  );
};
